<template>
  <component :is="rowData === undefined ? 'div' : 'div'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="rowData === undefined"
    >
      <h4 class="alert-heading">
        Gagal menemukan data
      </h4>
      <div class="alert-body">
        Tidak ada data ditemukan, Cek
        <b-link         class="alert-link"
          :to="{ name: 'jenis-dokumen-list'}"
        >
          Disini
        </b-link>
        untuk melihat data lainnya.
      </div>
    </b-alert>

    <template v-if="rowData">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >
          <b-tabs
            vertical
            content-class="col-12 col-md-9 mt-1 mt-md-0"
            pills
            nav-wrapper-class="col-md-3 col-12"
            nav-class="nav-left"
          >
            <!-- general tab -->
            <b-tab active>
              <!-- title -->
              <template #title>
                <feather-icon
                  icon="FileTextIcon"
                  size="18"
                  class="mr-50"
                />
                <span class="font-weight-bold">Data Jenis Dokumen</span>
              </template>

              <edit-info-card
                :row-data="rowData"
                :jenisUptOptions="jenisUptOptions.options"
                :kanwilOptions="kanwilOptions.options"
                :uptOptions="uptOptions.options"
                :jenisAssetOptions="jenisAssetOptions.options"
                :statusAssetOptions="statusAssetOptions.options"
              />
            </b-tab>
            <!--/ general tab -->
          </b-tabs>
        </b-col>
      </b-row>

      <!-- <b-row>
        <b-col
          cols="12"
          lg="6"
        >
          <user-view-user-timeline-card />
        </b-col>
        <b-col
          cols="12"
          lg="6"
        >
          <user-view-user-permissions-card />
        </b-col>
      </b-row> -->

    </template>

  </component>
</template>

<script>
import {
  BRow, BCol, BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import {
  // getJenisUPT,
  // getKanwil,
  getUPT,
  getJenisAsset,
  getStatusAsset,
  getAllJenisDokumen,
} from '@/connection-api/master'
import storeModule from '@/connection-api/jenis-dokumen/storeModule'
import EditInfoCard from './EditInfoCard.vue'
// import ViewDokumenLainnya from '../element/ViewDokumenLainnya.vue'
// import ViewDokumenFoto from '../element/ViewDokumenFoto.vue'

export default {
  components: {
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    // BLink,

    EditInfoCard,
    // ViewDokumenLainnya,
    // ViewDokumenFoto,
  },
  data() {
    return {
      jenisUptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis UPT --' },
        ],
      },
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Kanwil --' },
        ],
      },
      uptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      },
      jenisAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Asset --' },
        ],
      },
      statusAssetOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Asset --' },
        ],
      },
      assetId: null,
      dataMasterJenisDokumenLainnya: null,
      dataMasterJenisDokumenFoto: null,
    }
  },
  async beforeMount() {
    this.assetId = Number(this.$route.params.id)
  },
  mounted() {
    this.reloadData()
  },
  methods: {
    async reloadData() {
      const jenisDokumenLainnya = await getAllJenisDokumen(2)
      this.dataMasterJenisDokumenLainnya = jenisDokumenLainnya.data

      const jenisDokumenFoto = await getAllJenisDokumen(1)
      this.dataMasterJenisDokumenFoto = jenisDokumenFoto.data

      // const responseJenisUptOptions = await getJenisUPT()
      // this.mappingSelectOption(responseJenisUptOptions.data, this.jenisUptOptions.options)

      // const responseKanwilOptions = await getKanwil()
      // this.mappingSelectOptionIds(responseKanwilOptions.data, this.kanwilOptions.options)

      const responsejenisAssetOptions = await getJenisAsset()
      this.mappingSelectOption(responsejenisAssetOptions.data, this.jenisAssetOptions.options)

      const responseStatusAssetOptions = await getStatusAsset()
      this.mappingSelectOption(responseStatusAssetOptions.data, this.statusAssetOptions.options)

      this.reloadUPTOptions(this.rowData.data.wilayah)
    },
    async reloadUPTOptions(kanwilId) {
      this.uptFilter = null
      this.uptOptions = {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      }
      const responseUptOptions = await getUPT(kanwilId)
      this.mappingSelectOptionIds(responseUptOptions.data, this.uptOptions.options)
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    mappingSelectOptionIds(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
  },
  setup() {
    const rowData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'jenis-dokumen'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('jenis-dokumen/fetchData', { id: router.currentRoute.params.id })
      .then(response => { rowData.value = response.data })
      .catch(error => {
        if (error.response.status === 404) {
          rowData.value = undefined
        }
      })

    return {
      rowData,
    }
  },
}
</script>

<style>

</style>
